import { MutationTree } from "vuex";
import {
    SET_USER_REQUESTS,
    SET_SINGLE_REQUEST,
    SET_BRANDS,
    SET_COUNTRIES,
    SET_AFFILIATES,
    SET_TYPES_OF_CAMPAIGN,
    SET_TYPES_OF_ASSETS,
    SET_MEDIA,
    SET_REQUEST_STATUS,
    SET_IS_REFERENCE_DATA_LOADED,
    SET_REQUEST_MESSAGES,
    SET_UPLOAD_FILES,
    SET_STATS_REQUEST,
    SET_GLOBAL_SETTINGS,
    SET_DECISION_MESSAGES,
    SET_THEMES,
} from "./mutations-types";
import { IRequestState } from "./state";
import {
    IBrand,
    ICountry,
    IAffiliate,
    ITypeOfCampaign,
    ITypeOfAssets,
    IMedia,
    IRequestStatus,
    IRequestResponse,
    IRequest,
    IMessage,
    IRequestFile,
    IStatisticsResponse,
    IGlobalSettings,
    IDecisionMessage,
    ITheme,
} from "@/models";

export const mutations: MutationTree<IRequestState> = {

    [SET_USER_REQUESTS](state, payload: IRequestResponse): void {
        state.userRequests = payload;
    },

    [SET_SINGLE_REQUEST](state, payload: IRequest): void {
        state.singleRequest = payload;
    },

    [SET_BRANDS](state, payload: IBrand[]): void {
        state.brands = payload;
    },

    [SET_COUNTRIES](state, payload: ICountry[]): void {
        state.countries = payload;
    },

    [SET_AFFILIATES](state, payload: IAffiliate[]): void {
        state.affiliates = payload;
    },

    [SET_TYPES_OF_CAMPAIGN](state, payload: ITypeOfCampaign[]): void {
        state.typesOfCampaign = payload;
    },

    [SET_TYPES_OF_ASSETS](state, payload: ITypeOfAssets[]): void {
        state.typesOfAssets = payload;
    },

    [SET_MEDIA](state, payload: IMedia[]): void {
        state.media = payload;
    },

    [SET_IS_REFERENCE_DATA_LOADED](state, payload: boolean): void {
        state.isReferenceDataLoaded = payload;
    },

    [SET_REQUEST_MESSAGES](state, payload: IMessage[]): void {
        state.messages = payload;
    },

    [SET_REQUEST_STATUS](state, payload: IRequestStatus[]): void {
        state.requestStatus = payload;
    },

    [SET_UPLOAD_FILES](state, payload: IRequestFile[]): void {
        state.uploadFiles = payload;
    },

    [SET_STATS_REQUEST](state, payload: IStatisticsResponse): void {
        state.statisticsRequest = payload;
    },

    [SET_GLOBAL_SETTINGS](state, payload: IGlobalSettings): void {
        state.globalSettings = payload;
    },

    [SET_DECISION_MESSAGES](state, payload: IDecisionMessage[]): void {
        state.decisionMessages = payload;
    },

    [SET_THEMES](state, payload: ITheme[]): void {
        state.themes = payload;
    }
};
